import React, {memo} from 'react'

/* Cosmos */
import Select from './select/Select'

/* Components */
import HbImageView from '../../../../../components/HbImage/view/HbImageView'
import HbPlaceholderFrame from '../../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Actions */
import {actionCreators as productActionCreators} from '../../../../../redux/actions/productActions'

/* Utils */
import {formatPrice} from '../../../../../modules/product/productDesktopUtils'
import {resolveWithSettleContext} from '../../../../../common/async/promiseUtils'
import DataSet from '../../../../../utils/DataSet'

/* Constants */
import {
  DESKTOP_VARIANT_SHAPE_IMAGE_PROPS as VARIANT_SHAPE_IMAGE_PROPS,
  DESKTOP_VARIANT_TYPE_PROPS as VARIANT_TYPE_PROPS,
} from '../../../../../modules/variant/variantConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../../modules/analytics/davinci/davinciConstants'

/* Styles */
import s from './variant-dropdown.scss'

const VariantDropdown = memo(({
  dispatch,
  variant,
  activeVariant,
  onVariantChange,
  unAvailableVariants,
  isAvailableProduct,
  brandName,
  pageTypeForDavinci,
  isFashionProduct,
  productId,
  merchantName,
  sku,
  merchantId,
  listingId,
  price,
  categoryId,
  categoryName,
}) => {
  const selectedDropdownVariant = variant?.properties?.find(property => property?.isSelected)

  const handleSizeChart = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      page_type: pageTypeForDavinci,
      page_value: sku,
      location: 'buybox',
      text: 'Beden Tablosu',
      placement: '',
      position: '',
      url: '',
    })
    resolveWithSettleContext(
      dispatch(
        productActionCreators.getSizeChart.trigger({
          brand: brandName,
        }),
      )
    )
  }

  const handleOnVariantChange = (value) => {
    if (onVariantChange) {
      const selectedVariant = variant?.properties?.find(property => property?.value === value)
      onVariantChange(selectedVariant)
    }
  }

  return (
    <div className={s.root} data-test-id={'variant-dropdown'}>
      <div className={s.variantTitle}>
        <div className={s.variant}>
          <span className={s.propertyName} data-test-id={'variant-name'}>{`${selectedDropdownVariant?.name} :`}</span>
          <span className={s.propertyValue} data-test-id={'variant-value'}>
            {activeVariant?.values?.[selectedDropdownVariant?.name]}
          </span>
        </div>
        {
          selectedDropdownVariant?.name === 'Beden' && isFashionProduct &&
          <div
            className={s.variantExtra}
            data-test-id={'size-chart'}
            onClick={() => handleSizeChart()}
            data-hbus={DataSet.createComponentViewDataForDavinci({
              pageType: pageTypeForDavinci,
              pageValue: sku,
              placement: 'buybox',
              component: 'size chart',
              componentOrder: '10',
              componentDetail: 'Beden Tablosu',
              categoryHierarchy: `${categoryId}-${categoryName}`,
              productId: productId,
              merchantName: merchantName,
              merchantId: merchantId,
              listingId: listingId,
              price: `${price}`,
            })}>
            <i className={s.extraIcon}/>
            <span className={s.extraName}>{'Beden Tablosu'}</span>
          </div>
        }
      </div>
      <Select
        value={activeVariant?.values?.[selectedDropdownVariant?.name]}
        onChange={handleOnVariantChange}
        unAvailableVariants={unAvailableVariants}
        isAvailableProduct={isAvailableProduct}
        activeVariant={activeVariant}
        options={variant?.properties?.map(property => ({
          value: property?.value,
          label: property?.value,
          extraProps: property
        }))}
        placeholder={
          <div
            className={s.variantProperties}>
            <div className={s.variantWrapper}>
              {
                VARIANT_TYPE_PROPS[variant?.variantType]?.isShowImage &&
                selectedDropdownVariant?.thumbnail &&
                <div className={s.imageContainer} data-test-id={'image-container'}>
                  <HbPlaceholderFrame ratio={1}>
                    <HbImageView
                      image={{
                        alt: selectedDropdownVariant?.value,
                        src: selectedDropdownVariant?.thumbnail?.url,
                        size: `${VARIANT_SHAPE_IMAGE_PROPS[variant?.variantType][variant?.variantShape]?.width}-${VARIANT_SHAPE_IMAGE_PROPS[variant?.variantType][variant?.variantShape]?.height}`,
                        originSize: {
                          width: selectedDropdownVariant?.thumbnail?.width,
                          height: selectedDropdownVariant?.thumbnail?.height,
                        },
                      }}/>
                  </HbPlaceholderFrame>
                </div>
              }
              <div className={s.variantInfo}>
                <span className={s.name} data-test-id={'variant-value'}>
                  {activeVariant?.values?.[selectedDropdownVariant?.name]}
                </span>
                {
                  variant?.isShowPrice && selectedDropdownVariant?.price && (
                    <span className={s.price} data-test-id={'variant-price'}>
                      {formatPrice(selectedDropdownVariant?.price)}
                    </span>
                  )
                }
              </div>
            </div>
          </div>
        }/>
    </div>
  )
})

export default VariantDropdown
